(() => {
  const ROOT_SELECTOR = '[data-trade-confirmation]';
  const ACCEPTED_CLASS = 'is-accepted';

  const readStorage = (key) => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  };

  const isExpired = (record, expiryDays) => {
    if (!record || !record.acceptedAt) return true;
    const acceptedAt = new Date(record.acceptedAt).getTime();
    if (Number.isNaN(acceptedAt)) return true;
    const expiryMs = expiryDays * 24 * 60 * 60 * 1000;
    return Date.now() - acceptedAt > expiryMs;
  };

  const getCheckoutButton = (root) => {
    const scope = root.closest('.drawer__footer, .cart__blocks, .cart__footer');
    if (!scope) return null;
    return scope.querySelector('.cart__checkout-button');
  };

  const getCheckoutForm = (root, button) => {
    if (button && button.form) return button.form;
    const scope = root.closest('.drawer__footer, .cart__blocks, .cart__footer');
    if (!scope) return null;
    return scope.closest('form') || document.getElementById('cart') || document.getElementById('CartDrawer-Form');
  };

  const getDynamicButtons = (root) => {
    const scope = root.closest('.drawer__footer, .cart__blocks, .cart__footer');
    if (!scope) return [];
    return [...scope.querySelectorAll('.additional-checkout-buttons')];
  };

  const setDynamicButtonsVisible = (root, visible) => {
    getDynamicButtons(root).forEach((element) => {
      element.hidden = !visible;
      element.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
  };

  const hideError = (root) => {
    const error = root.querySelector('[data-trade-confirmation-error]');
    if (!error) return;
    error.hidden = true;
  };

  const showError = (root) => {
    const error = root.querySelector('[data-trade-confirmation-error]');
    if (!error) return;
    error.hidden = false;
  };

  const markAccepted = (root, accepted) => {
    const input = root.querySelector('[data-trade-confirmation-input]');
    root.classList.toggle(ACCEPTED_CLASS, accepted);
    if (accepted) {
      root.hidden = true;
      if (input) input.checked = true;
      setDynamicButtonsVisible(root, true);
    } else {
      root.hidden = false;
      if (input) input.checked = false;
      setDynamicButtonsVisible(root, false);
    }
    hideError(root);
  };

  const persistAcceptance = (root) => {
    const storageKey = root.dataset.storageKey || 'bladeworx-trade-confirmation-v1';
    writeStorage(storageKey, {
      acceptedAt: new Date().toISOString(),
      context: root.dataset.context || 'cart',
    });
  };

  const handleCheckboxChange = (root) => {
    const input = root.querySelector('[data-trade-confirmation-input]');
    if (!input) return;
    if (input.checked) {
      persistAcceptance(root);
      markAccepted(root, true);
    } else {
      markAccepted(root, false);
    }
  };

  const handleCheckoutAttempt = (event, root) => {
    const input = root.querySelector('[data-trade-confirmation-input]');
    if (!input || input.checked) return;
    event.preventDefault();
    event.stopPropagation();
    showError(root);
    input.focus();
  };

  const initRoot = (root) => {
    if (!root || root.dataset.tradeConfirmationReady === 'true') return;

    const input = root.querySelector('[data-trade-confirmation-input]');
    if (!input) return;

    const storageKey = root.dataset.storageKey || 'bladeworx-trade-confirmation-v1';
    const expiryDays = Number.parseInt(root.dataset.expiryDays || '180', 10);
    const checkoutButton = getCheckoutButton(root);
    const checkoutForm = getCheckoutForm(root, checkoutButton);
    const stored = readStorage(storageKey);
    const accepted = !isExpired(stored, expiryDays);

    markAccepted(root, accepted);

    input.addEventListener('change', () => handleCheckboxChange(root));

    if (checkoutButton) {
      checkoutButton.addEventListener('click', (event) => handleCheckoutAttempt(event, root));
    }

    if (checkoutForm) {
      checkoutForm.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        const isCheckoutSubmitter =
          !submitter ||
          submitter.name === 'checkout' ||
          submitter.id === 'checkout' ||
          submitter.classList.contains('cart__checkout-button');

        if (!isCheckoutSubmitter) return;
        handleCheckoutAttempt(event, root);
      });
    }

    root.dataset.tradeConfirmationReady = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  const observeMutations = () => {
    const observer = new MutationObserver(() => {
      initAll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      observeMutations();
    });
  } else {
    initAll();
    observeMutations();
  }
})();
